import React from "react";

import { Authentication } from "common/components/auth";

const ContractorRequired = props => (
  <Authentication
    authenticationRequired
    agreedToSRequired
    emailConfirmedRequired
    onAuthPath={window.location.pathname}
    requiredUserType="contractor"
    redirectTo="/login"
    {...props}
  />
);

export default ContractorRequired;
